import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AssetSearchDefinitionRequest, IAssetNameCriteria, IAssetStatusCriteria, IAssetTypeCriteria, IAssetTypeSelection, IContractorCriteria, IIndustryCriteria, ILocationCriteria, IOperatorCriteria } from '../data-access/assetSearch.service';


// Allow mesagng between components to manage the position of the locator on its layer
@Injectable({
    providedIn: 'root'
})
export class LocatorMediator {

    private locatorPositionSource = new Subject<[number, number] | null>();
    locatorPosition$ = this.locatorPositionSource.asObservable();

    private locatorVisibleSource = new BehaviorSubject<boolean>(false);
    locatorVisible$ = this.locatorVisibleSource.asObservable();

    publishLocatorPosition(locatorPosition: [number, number]) {
        this.locatorVisibleSource.next(true);
        this.locatorPositionSource.next(locatorPosition);
    }

    hideLocator() {
        this.locatorVisibleSource.next(false);
        //this.locatorPositionSource.next(null);
    }
    showLocator() {
        this.locatorVisibleSource.next(true);
        //this.locatorPositionSource.next(null);
    }
    locatorVisible(): boolean {
        return this.locatorVisibleSource.value;
    }
}
